import React from 'react';
import { Link } from 'react-router-dom';

import styles from './marketing.module.css';
import { SEO } from '../components/SEO.jsx';

import heroImage from '../pictures/Bull-Bear.avif';
import opportunityImage from '../pictures/Professional digging-1.webp';
import proofImage from '../pictures/One digging for gold.webp';

const investorCards = [
  {
    tag: 'Problem',
    title: 'Trust is becoming a product feature',
    text: 'Customers, institutions, and AI-driven systems increasingly need records that can be checked after the fact.',
  },
  {
    tag: 'Platform',
    title: 'Multiple paths to revenue',
    text: 'Trust.it, data-center services, dedicated generator hardware, and licensing create several commercial routes.',
  },
  {
    tag: 'Protection',
    title: 'Patent-backed technology',
    text: 'Granted patents in major regions give the company a stronger foundation for partnerships and licensing discussions.',
  },
];

export const Investors = () => (
  <main className={styles.page}>
    <SEO
      title="Back-Step Blockchain Investors"
      description="Investor and partner overview for Back-Step Blockchain Systems, a patent-backed trust platform for authenticity, digital records, services, and licensing."
      path="/investors"
    />

    <section className={styles.hero}>
      <img className={styles.heroImage} src={heroImage} alt="Financial market symbols" />
      <div className={styles.heroOverlay} />
      <div className={styles.heroContent}>
        <p className={styles.kicker}>Investors and partners</p>
        <h1 className={styles.heroTitle}>A commercial platform for the next trust economy.</h1>
        <p className={styles.heroText}>
          Back-Step Blockchain is positioned for markets where proof, authenticity, and reliable records can
          become revenue-generating services.
        </p>
        <div className={styles.actions}>
          <Link className={styles.primaryAction} to="/contact">Start a discussion</Link>
          <Link className={styles.secondaryAction} to="/story">Patent story</Link>
        </div>
      </div>
    </section>

    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>Investment logic</p>
          <h2>Move from invention to market adoption.</h2>
          <p>
            The opportunity is to turn a protected technical invention into products customers can understand,
            adopt, and pay for.
          </p>
        </div>
        <div className={styles.grid}>
          {investorCards.map((card) => (
            <article className={styles.card} key={card.title}>
              <div className={styles.cardBody}>
                <span className={styles.tag}>{card.tag}</span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className={styles.sectionAlt}>
      <div className={styles.split}>
        <div className={styles.splitCopy}>
          <p className={styles.kicker}>Growth model</p>
          <h2>Several business models can grow from the same trust platform.</h2>
          <p>
            The company can serve individuals through Trust.it, support enterprises through dedicated infrastructure,
            and license technology to partners who want trust functions embedded in their own products.
          </p>
          <ul className={styles.list}>
            <li>Usage-based revenue from trust records</li>
            <li>Hardware and service revenue for business customers</li>
            <li>Licensing for technology and semiconductor partners</li>
          </ul>
        </div>
        <div className={styles.photoPanel}>
          <img src={opportunityImage} alt="Professional team working toward a larger opportunity" />
        </div>
      </div>
    </section>

    <section className={styles.sectionDark}>
      <div className={styles.split}>
        <div className={styles.splitCopy}>
          <p className={styles.kicker}>Partner ask</p>
          <h2>We are looking for commercial and investment partners.</h2>
          <p className={styles.lead}>
            The strongest partner will help convert technical strength into international marketing,
            business development, and operational scale.
          </p>
          <Link className={styles.primaryAction} to="/contact">Contact us</Link>
        </div>
        <div className={styles.photoPanel}>
          <img src={proofImage} alt="Searching for valuable opportunity" />
        </div>
      </div>
    </section>
  </main>
);
